import { render, staticRenderFns } from "./BackofficeAvaliacaoPreOperatoria.vue?vue&type=template&id=616f28fa"
import script from "./BackofficeAvaliacaoPreOperatoria.vue?vue&type=script&lang=ts"
export * from "./BackofficeAvaliacaoPreOperatoria.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeAvaliacaoPreOperatoria.vue?vue&type=style&index=0&id=616f28fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports